import { DocumentationPageAnchor } from "@supernova-studio/model";
import { z } from "zod";

//
// Read
//

export const DTODocumentationPageAnchor = DocumentationPageAnchor;

export const DTOGetDocumentationPageAnchorsResponse = z.object({
  anchors: z.array(DTODocumentationPageAnchor),
});

export type DTODocumentationPageAnchor = z.infer<typeof DTODocumentationPageAnchor>;
export type DTOGetDocumentationPageAnchorsResponse = z.infer<typeof DTOGetDocumentationPageAnchorsResponse>;
